import { Button, Modal, Col, Container, Row , Form} from "react-bootstrap";
import React, { useEffect, useState } from "react";
import { AlertaModel } from '../models/alert.model';
import storageService from "../services/storage.service";
import UserService from "../services/user.service";
import { useTranslation } from 'react-i18next';
import ReactDatatable from "@ashvin27/react-datatable";
import { LabelDynamic } from "./LabelDynamic";
import { dataTableConfig } from "../configs/data-table.config";
import { RequestInputOutputParamsModel, RequestInputOutputParamsModelDefault } from "../models/requestInputOutputParams.model";
import { DatasetDefault, DatasetModel } from "../models/dataset.model";
import _ from 'lodash';

export const ModalAlertDetail = (props: any) => {
  const user = storageService.getUser();
  const { t } = useTranslation();

  useEffect(() => {
    if (props.AlertId != undefined){
     getList(null)
    }
  }, [props.AlertId])

  useEffect(() => {
    if (props.AlertId != undefined){
     getList(null)
    }
  }, [])

  const [data, setData] = useState<DatasetModel>();
  const [dataset, setDataset] = useState<DatasetModel>({
    ...JSON.parse(JSON.stringify(DatasetDefault)), dataset: 'alert_detail', filters: {
      id_alert: props.AlertId
    },
    sort: {
      field: 'fullname',
      orientation: 'asc'
    }
  });
  const [isLoading, setLoading] = useState(false);

  const tableChangeHandler = async (data) => {
    await getList(data);
  };

  const getList = async (dataTable) => {
    setLoading(true);
    let requestParams: RequestInputOutputParamsModel = { ...RequestInputOutputParamsModelDefault, datasets: [dataset] };

    if (!requestParams.parameters) {
      requestParams.parameters = { id_alert: props.AlertId };
    }

    if (dataTable !== null && requestParams?.datasets) {
      let dataSet = requestParams.datasets[0];
      let pagination = dataSet.pagination;

      pagination.page_number = dataTable.page_number;
      pagination.records_pages = dataTable.page_size;
      dataSet.sort.field = dataTable.sort_order.column;
      dataSet.sort.orientation = dataTable.sort_order.order;
    } else {
      let pagination = requestParams.datasets[0].pagination;
      pagination.page_number = DatasetDefault.pagination.page_number;
      pagination.records_pages = DatasetDefault.pagination.records_pages;
    }

    const response: any = await UserService.getAlertDetailByUserIdByAlertId(requestParams);


    if (response.success === true && response.result) {
      let d: DatasetModel = _.last(_.filter(response.result.datasets, { dataset: 'alert_detail' }));

     
      setData(d);
    } else {
      requestParams.datasets[0].data = null;
      setData(requestParams.datasets[0]);
    }
    setLoading(false);

  }

  const localDataTableConfig = {
    ...dataTableConfig,
    language: {
      filter: t(`DATA_GRID.SEARCH`),
      info: t(`DATA_GRID.INFO_START`) +
        " _START_ " + t(`DATA_GRID.INFO_TO`) +
        " _END_ " + t(`DATA_GRID.INFO_TOTAL`) +
        " _TOTAL_ " + t(`DATA_GRID.INFO_RECORDS`),
      no_data_text: t(`DATA_GRID.NO_RECORDS_FOUND`),
      pagination: {
        first: t(`DATA_GRID.BUTTON_FIRST`),
        previous: t(`DATA_GRID.BUTTON_PREVIOUS`),
        next: t(`DATA_GRID.BUTTON_NEXT`),
        last: t(`DATA_GRID.BUTTON_LAST`),
      },
      loading_text: t('DATA_GRID.LOADING')
    },
    sort:{ column: "fullName", order: "asc" }
  }

  const columns = [
    {
      key: "branchname",
      text: t("MODULE_ALERT.GRID_ALERT_DETAIL_BRANCHNAME"),
      align: "left",
      sortable: false,
    },
    {
      key: "code_equipment",
      text: t("MODULE_ALERT.GRID_ALERT_DETAIL_CODE_EQUIPMENT"),
      align: "left",
      sortable: false,
    },
    {
      key: "value",
      text: t("MODULE_ALERT.GRID_ALERT_DETAIL_CODE_VALUE"),
      align: "left",
      sortable: false,
      cell: (record) => {
        return <LabelDynamic value={record.value} value_type={record.value_type}/>;
      },
    },
    {
      key: "value_002",
      text: t("MODULE_ALERT.GRID_ALERT_DETAIL_CODE_VALUE2"),
      align: "left",
      sortable: false,
      cell: (record) => {
        return record.value_type_002 ? <LabelDynamic value={record.value_002} value_type={record.value_type_002}/> : '-';
      },
    }
  ];


  return (
    <>
      <Modal as={Modal.Dialog} centered show={props.Show} onHide={props.HandleClose}  size="lg">
        <Modal.Header>
          <Modal.Title className='h6'>{props.Title}</Modal.Title>ss
          <Button variant='close' aria-label='Close' onClick={props.HandleClose} />
        </Modal.Header>
        <Modal.Body>
      
        <ReactDatatable
          loading={isLoading}
          config={localDataTableConfig}
          records={data?.data ? data?.data : []}
          columns={columns}
          dynamic={true}
          total_record={data?.pagination?.total_records ? data?.pagination?.total_records : 0}
          onChange={tableChangeHandler}
          className='table table-hover user-table align-items-center'
          sort={{ column: "email", order: "asc" }}
        />

       
        </Modal.Body>
        <Modal.Footer>
        <Button variant="primary" onClick={props.HandleClose}>{props.ButtonCloseLabel}</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
